import { createSignal } from "solid-js";

import { BuildConfig } from "@uic/adapters/confenv";
import { StorageBackendType } from "@uic/adapters/slorgproto";

import { fromProtoString } from "./backend-type.js";

const ALL_BACKENDS = [
  StorageBackendType.FILESYSTEM,
  StorageBackendType.WEBDAV,
  StorageBackendType.LOCALSTORAGE,
];

const [allowedStorageBackends, setAllowedStorageBackends] =
  createSignal(ALL_BACKENDS);

export { allowedStorageBackends };

/**
 * Fetch server status (unauthenticated) and populate allowed backends.
 */
export async function fetchServerStatus() {
  try {
    const base = BuildConfig.WSC_ADDRESS.replace(/\/+$/, "");
    const res = await fetch(`${base}/wscapi/status`);
    if (!res.ok) return;
    const data = await res.json();
    if (
      Array.isArray(data.allowed_storage_backends) &&
      data.allowed_storage_backends.length > 0
    ) {
      const parsed = data.allowed_storage_backends
        .map((s) => fromProtoString(s))
        .filter((v) => v !== undefined);
      if (parsed.length > 0) {
        setAllowedStorageBackends(parsed);
      }
    }
  } catch {
    // intentionally empty
  }
}

/**
 * Check whether a given backend type enum value is allowed.
 * @param {number} backendType A StorageBackendType enum value
 * @returns {boolean} Whether the backend is allowed
 */
export function isBackendAllowed(backendType) {
  return allowedStorageBackends().includes(backendType);
}
